<template>
    <aside aria-label="Shop basket" class="c-basket">
        <slide-in-overlay :is-open="isOpen" @close="close">
            <template v-slot:heading> {{ translations['Cart'] }} </template>

            <template v-slot:body>
                <cart-items></cart-items>
            </template>

            <template v-slot:footer>
                <div class="o-summary">
                    <div class="o-summary__shipping">
                        <span>{{ translations['Shipping'] }}</span>
                        <span>{{ cart.shippingCost }}</span>
                    </div>
                    <div class="o-summary__shipping" v-if="cart.totalDiscount">
                        <span>{{ translations['Discount'] }}</span>
                        <span>{{ cart.totalDiscount }}</span>
                    </div>
                    <div class="o-summary__total">
                        <span> {{ translations['Price in total'] }}</span>
                        <span>{{ cart.priceInclVat }}</span>
                    </div>
                </div>
                <div class="c-basket__buttons">
                    <a
                        :href="siteUrl + 'shop/checkout'"
                        class="o-btn o-btn--fullwidth"
                        >{{ translations['Go to checkout'] }}</a
                    >
                    <a
                        :href="siteUrl + 'shop/cart'"
                        class="o-btn o-btn--transparent o-btn--fullwidth"
                        >{{ translations['View cart'] }}</a
                    >
                </div>
            </template>
        </slide-in-overlay>
    </aside>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

import SlideInOverlay from './SlideInOverlay.vue'
import CartItems from './CartItems.vue'

export default {
    name: 'Basket',
    components: {
        SlideInOverlay,
        CartItems,
    },
    data: () => {
        return {
            isUpdatingCart: false,
            itemsUpdating: [],
        }
    },
    computed: {
        ...mapState({
            cart: (state) => state.cart.cart,
            translations: (state) => state.app.translations,
            siteUrl: (state) => state.app.siteUrl,
        }),
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close() {
            this.$store.dispatch('cart/close')
        },
    },
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables.scss';

.c-basket {
    .c-slideInOverlay__inner {
        max-width: 400px;
    }

    &__item {
        display: flex;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid $c-light-grey;

        .image {
            line-height: 0;
            margin-right: 14px;
            min-width: 95px;
        }

        .data {
            width: 100%;
        }

        .heading {
            color: $c-black;
            font-family: $font-heading;
            font-size: 20px;
            letter-spacing: -0.15px;
            line-height: 20px;
            text-transform: uppercase;
        }

        .props {
            margin-top: 8px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: -0.08px;
            line-height: 13px;
            text-transform: uppercase;
        }

        .options {
            margin-top: 8px;
        }

        .option {
            font-size: 11px;
            letter-spacing: -0.08px;
            line-height: 13px;
            span {
                text-transform: uppercase;
                font-weight: 700;
            }
        }

        .actions {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 18px;

            &__holder {
                position: relative;
                overflow: hidden;
            }

            .o-loaderInline {
                display: none;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                margin-left: -22px;
                z-index: 3;

                div {
                    background: $c-white;
                }
            }

            &--loading {
                .actions__holder {
                    &::before {
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                        display: block;
                        content: '';
                        background: $c-black;
                        border: 2px solid $c-black;
                        z-index: 2;
                        border-radius: 25px;
                    }
                }

                .o-loaderInline {
                    display: inline-block;
                }
            }
        }

        .price {
            font-family: $font-heading;
            font-size: 19px;
            letter-spacing: -0.15px;
            line-height: 20px;
            text-align: right;
        }
    }

    &__buttons {
        padding-top: 23px;
        .o-btn {
            margin-bottom: 5px;
        }
    }
}
</style>
